import React from 'react'
import { DivContentBox, DivTitleBox } from './styled'

const RoundCornerIBox = ({ title, children, icon, className }) => (
  <div className={`ibox float-e-margins animated fadeIn section-shadow ${className}`}>
    <DivTitleBox className='ibox-title d-flex justify-content-between'>
      <h5>{title}</h5>
      {icon !== undefined ? (
        <div className='text-end' style={{ cursor: 'pointer' }}>
          {icon}
        </div>
      ) : null}
    </DivTitleBox>
    <DivContentBox className='ibox-content table-responsive'>{children}</DivContentBox>
  </div>
)

export default RoundCornerIBox
